import { useGetDealGeneralPartnerViewV3 } from "@vega-api/generated/deal/deal";

export const useDealName = (dealId?: string) => {
  const { data: dealName, isLoading } = useGetDealGeneralPartnerViewV3(
    dealId ?? "",
    {
      query: {
        enabled: !!dealId,
        select: (data) => data.data?.deal.name,
      },
    },
  );

  return {
    dealName: dealName || "",
    isLoading,
  };
};
